import { Image, Typography, Flex } from 'antd'
import CustomButton from "../../components/CustomButton/Button"
import { useNavigate } from 'react-router-dom'
import CrashImage from "../../assets/images/crash.png"
import "./Error.scss"

const { Title } = Typography

const ErrorUI = () => {
  const navigate = useNavigate();

  return (
    <div className='error-container'>
      <Image src={CrashImage} preview={false} alt='Not Found' height={300} />
      <div className='error-message-container'>
        <Title level={1} className='oops-text'>
          Oops!
        </Title>
        <Title level={3} className='error-text'>
          Something went wrong! Please reload the page
        </Title>
        <Flex gap={10}>
          <CustomButton
            variant="solid"
            color="primary"
            onClick={() => navigate("/dashboard")}
          >
            Go To Dashboard
          </CustomButton>
          <CustomButton
            variant="outlined"
            color="primary"
            onClick={() => navigate("/support")}
          >
            Contact Support
          </CustomButton>
        </Flex>
      </div>
    </div>
  )
}

export default ErrorUI